import { useEffect, useRef } from "react";
import useModal from "../Modal/useModal";
import Modal from "../Modal";
import { Box, Typography } from "@mui/material";
import { ReactComponent as CloseIcon } from "../../../assets/icons/close-icon.svg";
import { WhiteButton } from "../../MUI/buttons/button";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";

import classes from "./index.module.scss";
import { usePopup } from "./hooks/usePopup";
import { useQueryClient } from "@tanstack/react-query";
import { useLocation } from "react-router-dom";

export default function WebinarPopup() {
  const modalRef = useRef();
  const { pathname } = useLocation();
  const { handleOpen, handleClose } = useModal(modalRef);
  const { data, isFetching } = usePopup({ slug: "webinar" });
  const queryClient = useQueryClient();
  const user = queryClient.getQueryData(["user"])?.data;

  const customFields = data?.popup?.custom_fields;
  const date = customFields?.date;
  const link = customFields?.link;
  const subtitle = customFields?.subtitle;
  const buttonText = customFields?.button_text;
  const text = customFields?.text;
  const time = customFields?.time;
  const title = customFields?.title;
  const type = customFields?.type;

  useEffect(() => {
    let timeout;
    if (!!customFields && !pathname.includes("thank-you")) {
      timeout = setTimeout(() => {
        handleOpen();
        clearTimeout(timeout);
      }, 10000);

      return () => {
        clearTimeout(timeout);
        handleClose();
      };
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [customFields]);

  if (!customFields || isFetching || pathname.includes("thank-you"))
    return null;

  return (
    <Modal modalRef={modalRef} className={classes.dialog}>
      <Box className={classes.modal}>
        <Box className={classes.modal__header}>
          <Box className={classes.modal__top}>
            {type ? (
              <Box className={classes.modal__badge}>{type.toString()}</Box>
            ) : null}
            <button onClick={handleClose} className={classes.modal__closeBtn}>
              <CloseIcon />
            </button>
          </Box>
          {title ? (
            <Typography
              component={"h2"}
              variant={"h2"}
              className={classes.modal__title}
            >
              {title.toString()}
            </Typography>
          ) : null}
          {subtitle ? (
            <Typography component={"h3"} className={classes.modal__subtitle}>
              {subtitle.toString()}
            </Typography>
          ) : null}
        </Box>

        {text ? (
          <Typography className={classes.modal__text}>
            {text.toString()}
          </Typography>
        ) : null}
        {date || time ? (
          <Typography className={classes.modal__date}>
            {date ? <span>{date.toString()}</span> : null}
            {time ? <span>{time.toString()}</span> : null}
          </Typography>
        ) : null}
        <Box className={classes.modal__actions}>
          <WhiteButton
            component={"a"}
            target={"_blank"}
            href={link.toString()}
            variant="contained"
            endIcon={<ChevronRightIcon />}
            onClick={() => {
              window.dataLayer.push({
                event: "button_click",
                type: "webinar",
                user: !!user ? user.users.email : "Unauthorized",
              });
              handleClose();
            }}
          >
            {buttonText ? buttonText.toString() : "Join the Webinar"}
          </WhiteButton>
        </Box>
      </Box>
    </Modal>
  );
}
